import * as Sentry from "@sentry/vue";
import router from "@/router";
import { App } from "@vue/runtime-core";

export const sentryInit = (app: App) => {
  if (process.env.VITE_USER_NODE_ENV != "local") {
    Sentry.init({
      app,
      dsn: process.env.VITE_SENTRY_DSN as string,
      release: "PartnerPortal@" + process.env.VITE_APP_VERSION,
      integrations: [
        Sentry.browserTracingIntegration({ router }),
        Sentry.replayIntegration(),
      ],
      // Set tracesSampleRate to 1.0 to capture 100%
      // of transactions for performance monitoring.
      // We recommend adjusting this value in production
      tracesSampleRate: 1.0,
      environment: process.env.NODE_ENV as string,
    });
  }
};
